import React from 'react';
import { Heading } from '../components/heading';
import { EnvelopeIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';

const Support = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <Heading level={1}>Soporte Técnico</Heading>
      <p className="mt-2 text-sm text-zinc-500">
        Estamos para ayudarte. Contáctanos por cualquiera de los siguientes medios.
      </p>

      <div className="mt-8 grid gap-6 sm:grid-cols-2">
        {/* Email */}
        <a
          href="mailto:plataforma@surelia.mx"
          className="group flex items-start gap-4 rounded-xl border border-zinc-200 bg-white p-6 shadow-sm transition hover:shadow-md hover:border-azul-surelia/40"
        >
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-azul-surelia/10 text-azul-surelia group-hover:bg-azul-surelia group-hover:text-white transition">
            <EnvelopeIcon className="h-6 w-6" />
          </div>
          <div>
            <h3 className="text-sm font-semibold text-zinc-900">Correo electrónico</h3>
            <p className="mt-1 text-sm text-azul-surelia font-medium">plataforma@surelia.mx</p>
            <p className="mt-2 text-xs text-zinc-400">Respuesta en horario laboral</p>
          </div>
        </a>

        {/* WhatsApp */}
        <a
          href="https://wa.me/525523090790?text=Hola!%20Tengo%20una%20pregunta%20sobre%20Surelia..."
          target="_blank"
          rel="noopener noreferrer"
          className="group flex items-start gap-4 rounded-xl border border-zinc-200 bg-white p-6 shadow-sm transition hover:shadow-md hover:border-green-500/40"
        >
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-green-50 text-green-600 group-hover:bg-green-500 group-hover:text-white transition">
            <ChatBubbleLeftRightIcon className="h-6 w-6" />
          </div>
          <div>
            <h3 className="text-sm font-semibold text-zinc-900">WhatsApp</h3>
            <p className="mt-1 text-sm text-green-600 font-medium">+52 55 2309 0790</p>
            <p className="mt-2 text-xs text-zinc-400">Atención inmediata</p>
          </div>
        </a>
      </div>
    </div>
  );
};

export default Support;
